import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { PdpGalleryWithLightboxProps } from "./PDP_Lightbox/use-pdp-gallery-with-lightbox";
import { pipe } from "fp-ts/function";
import { nonEmptyArray, option } from "fp-ts";
import { ModalRootPortalEntrance } from "../../components/_shared-components/technical/ModalRootPortalEntrance";
import { PDPLightbox } from "./PDP_Lightbox/PDPLightbox";
import React from "react";
import { css } from "@emotion/react";
import { nonEmpty } from "../../utils/fp/small-fp-utils";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { usePdpTranslations } from "./PdpTranslationsContext";

export const PDPGalleryModalRoot: ReactTFC<{
  galleryWithLightbox: PdpGalleryWithLightboxProps;
}> = props => {
  const t = usePdpTranslations();
  const closeLabel = t("closeModalBtnLabel");

  if (!props.galleryWithLightbox) {
    return null;
  }

  const { isModalActive, modalIdx, closeModal, galleryConfig } = props.galleryWithLightbox;

  const elements = pipe(
    [galleryConfig.primaryImage, ...galleryConfig.scrollingGalleryElements].filter(nonEmpty),
    nonEmptyArray.fromArray,
    option.toUndefined,
  );

  if (!elements) {
    return null;
  }

  return (
    <ModalRootPortalEntrance>
      <div className={isModalActive ? "visible" : "hidden"} css={modalWrapper}>
        <PDPLightbox
          isVisible={isModalActive}
          elements={elements}
          initiallyActiveIdx={modalIdx}
          closeModal={closeModal}
          closeLabel={closeLabel}
        />
      </div>
    </ModalRootPortalEntrance>
  );
};
const modalWrapper = css`
  position: fixed;
  z-index: 100;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  background-color: ${CSS_COLORS.White};

  overflow-y: scroll;

  //visibility: hidden;
  display: none;
  &.visible {
    //visibility: visible;
    display: block;
  }
`;
